import {IBaseFormFieldSettings} from "../base-form-field.settings";

export interface IFileFieldSettings extends IBaseFormFieldSettings {
  isMultiple?: boolean;
}
